<template>
    <div id="content">
        <router-link :to="$route.path.split('/').slice(0, -1).join('/')" class="back-link"><i class="bi bi-chevron-left"></i> {{ $t('users.new.back') }}</router-link>
        <div class="admin-card edit-card">
            <div v-if="loading" class="text-center py-4"><span class="loading"></span></div>
            <div v-if="!loading">
                <div class="admin-section-label">
                    <i class="bi bi-person-plus"></i>
                    {{ $t('users.new.title') }}
                </div>
                <form @submit.prevent="createUser" autocomplete="off">
                    <div class="form-grid">
                        <div class="form-row">
                            <label class="form-label">{{ $t('users.new.form.email') }}</label>
                            <input type="text" class="form-control" v-model="username" placeholder="user@email.com" required>
                        </div>
                        <div class="form-row">
                            <label class="form-label">{{ $t('users.new.form.plan') }}</label>
                            <select v-model="plan" class="form-select" required>
                                <option value="" disabled>{{ $t('users.new.form.selectPlan') }}</option>
                                <option v-for="p in plans" :value="p.id">{{ p.title }} | {{ p.price.toLocaleString() }} ₸ / {{ cycles[p.cycle - 1].text || $t('users.new.form.monthAbbr') }}</option>
                            </select>
                        </div>
                        <div class="form-row">
                            <label class="form-label">{{ $t('users.new.form.role') }}</label>
                            <select v-model="role" class="form-select" required>
                                <option value="" disabled>{{ $t('users.new.form.selectRole') }}</option>
                                <option v-for="option in options" :value="option.value">{{ option.text }}</option>
                            </select>
                        </div>
                        <div class="form-row">
                            <label class="form-label">{{ $t('users.new.form.password') }}</label>
                            <input type="password" class="form-control" v-model="password" autocomplete="new-password" minlength="8" maxlength="50" :placeholder="$t('users.new.form.passwordPlaceholder')" required>
                        </div>
                    </div>
                    <div class="form-actions">
                        <button type="submit" class="btn-purple">
                            <i class="bi bi-check2"></i>
                            <span>{{ $t('users.new.submit') }}</span>
                        </button>
                        <button type="button" class="btn-ghost" @click="$router.go(-1)">{{ $t('users.new.cancel') }}</button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</template>

<script>
import { cycles } from '../../../lib/utils'

export default {
    data:() => ({
        username: '',
        password: '',
        plan: '',
        role: '',
        plans: [],
        cycles: cycles,
        loading: false
    }),
    computed: {
        options() {
            return [
                { text: this.$t('users.new.roles.admin'), value: 'admin' },
                { text: this.$t('users.new.roles.user'), value: 'user' }
            ]
        }
    },
    async mounted() {
        this.plans = await this.getPlans()
    },
    methods: {
        async getPlans() {
            let response = await this.$api.getPlans()
            if(response.result === 'SUCCESS') return response.data.plans
            return []
        },
        async createUser() {
            let response = await this.$api.createUser({
                username: this.username,
                password: this.password,
                plan: this.plan,
                role: this.role
            })
            this.$notify({ text: response.msg, type: response.result.toLowerCase() })
            if(response.result === 'SUCCESS') this.$router.push('/users')
        }
    }
}
</script>

<style scoped>
.back-link {
    display: inline-flex;
    align-items: center;
    gap: 6px;
    color: #64748b;
    font-size: 13px;
    font-weight: 500;
    text-decoration: none;
    margin-bottom: 14px;
    transition: color 0.15s ease;
}
.back-link:hover {
    color: #6d28d9;
}
.back-link i {
    font-size: 14px;
}

.edit-card {
    padding: 24px;
    max-width: 600px;
}

.form-grid {
    display: flex;
    flex-direction: column;
    gap: 16px;
}

.form-row {
    display: grid;
    grid-template-columns: 120px 1fr;
    align-items: center;
    gap: 16px;
}

.form-row .form-label {
    margin-bottom: 0;
    font-size: 13px;
    color: #64748b;
    font-weight: 500;
    text-transform: none;
    letter-spacing: 0;
}

.form-actions {
    display: flex;
    gap: 10px;
    margin-top: 24px;
    padding-top: 18px;
    border-top: 1px solid #e5e7eb;
    flex-wrap: wrap;
}
</style>
